export const firebaseConfig = {
  apiKey: "AIzaSyDLvCRkCe2A_zUuz0Ey6uZzR8HX6lhnekc",
  authDomain: "mma-2-4eb8d.firebaseapp.com",
  databaseURL: "https://mma-2-4eb8d-default-rtdb.firebaseio.com",
  projectId: "mma-2-4eb8d",
  storageBucket: "mma-2-4eb8d.appspot.com",
  messagingSenderId: "983889931524",
  appId: "1:983889931524:web:fa9841137432d486c1f451",
  measurementId: "G-D6L1Q7PN2N"
};
